import styled from 'styled-components';
import { mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  margin-bottom: var(--space-1000);
  border: 1px solid var(--border-success);
  border-radius: var(--radius-brand);
  padding: var(--space-400);
  gap: var(--space-400);
  display: flex;
`;
export const TickContainer = styled.div `
  border-radius: 50%;
  background-color: var(--bg-success);
  color: var(--icon-on-brand);
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: var(--space-200);

  ${mediaQueries.tablet} {
    margin-right: 0;
  }
`;
export const Content = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
`;
export const Title = styled.div `
  display: flex;
  align-items: center;
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-500);
  line-height: var(--font-line-height-400);
  letter-spacing: var(--font-letter-spacing-denser);
`;
export const Description = styled.div `
  font-size: var(--font-size-400);
  line-height: var(--font-line-height-400);
  margin-bottom: var(--space-200);
`;
export const Footer = styled.div `
  display: flex;
  gap: var(--space-400);
`;
